export const mapConstants = {
    showModal: 'gim:show-modal',
    closeModal: 'gim:close-modal',
    selectFeature: 'gim:select-feature',
    unselectFeature: 'gim:unselect-feature',
    updateFeature: 'gim:update-feature',
    newFeatureInitialize: 'gim:feature-initialize',
    newFeatureFinished: 'gim:feature-finished',
    newFeatureShowModal: 'gim:feature-show-modal',
    showNotifyModal: 'gim:show-notify-modal',
    closeNotifyModal: 'gim:close-notify-modal',

    mapReload: 'map.reload',
    reloadActivity: 'gim:reload-activity',
    reloadOverdue: 'gim:reload-overdue',
    reloadAccountable: 'gim:reload-accountable',
};
